/* A view of the real product quantity. The sticky input deliberately has no
   name/form association, so Shopify receives exactly one quantity value. */
if (!customElements.get('slept-sticky-quantity')) {
  customElements.define('slept-sticky-quantity', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.input = this.querySelector('input');
      this.productForm = document.getElementById(this.getAttribute('form'));
      this.scope = this.closest('.slept-product');
      if (!this.input || !this.productForm || !this.scope) return;

      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');
        const source = this.source;
        if (!button || !source || source.disabled) return;
        event.preventDefault();
        const previous = source.value;
        if (Number(button.dataset.quantityStep) > 0) source.stepUp();
        else source.stepDown();
        if (source.value !== previous) source.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }, options);
      this.input.addEventListener('change', () => {
        const source = this.source;
        if (!source || source.disabled) return;
        const min = Number(source.min || 1);
        const max = source.max === '' ? Infinity : Number(source.max);
        const step = Number(source.step) > 0 ? Number(source.step) : 1;
        let value = this.input.value === '' ? min : this.input.valueAsNumber;
        if (!Number.isFinite(value)) value = min;
        value = min + Math.round((value - min) / step) * step;
        // Keep the maximum aligned to the same quantity-rule step base.
        const allowedMax = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
        source.value = String(Math.max(min, Math.min(allowedMax, value)));
        source.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }, options);
      this.scope.addEventListener('change', (event) => {
        if (event.target === this.source) this.sync();
      }, options);
      this.productForm.addEventListener('variant:change', () => this.sync(), options);
      this.observer = new MutationObserver(() => this.sync());
      this.sync();
    }

    get source() {
      const source = this.productForm?.elements.namedItem('quantity');
      return source instanceof HTMLInputElement ? source : null;
    }

    sync() {
      const source = this.source;
      this.hidden = !source;
      if (!source) return;
      if (this.observedSource !== source) {
        this.observer?.disconnect();
        this.observedSource = source;
        this.observer?.observe(source, { attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'value'] });
      }
      ['min', 'max', 'step'].forEach((name) => {
        if (source.hasAttribute(name)) this.input.setAttribute(name, source.getAttribute(name));
        else this.input.removeAttribute(name);
      });
      this.input.value = source.value;
      this.input.disabled = source.disabled;
      const value = Number(source.value);
      this.querySelector('[data-quantity-step="-1"]').disabled = source.disabled || (source.min !== '' && value <= Number(source.min));
      this.querySelector('[data-quantity-step="1"]').disabled = source.disabled || (source.max !== '' && value >= Number(source.max));
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.observedSource = null;
    }
  });
}
